import { connect } from "react-redux";
import PremierUnavailableMessage from "../../components/PremierUnavailableMessage/index.jsx";

export default connect()(PremierUnavailableMessage);
